import { estadoActividades, situacionfinanciera, ACvariacionHP, ACEstadoCambiosSF, ACEstadoPasivosC, ACNotasEF, ACEstadoAnaliticoA,ACEstadoFlujoE,ACEstadoAnaliticoDyOP, IPEstadoAnaliticoI, IPEstadoAnaliticoEPECPOG, IPEstadoAnaliticoEPEPCE, IPEstadoAnaliticoEPECF, IPEstadoAnaliticoEPECP, IPEstadoAnaliticoEPECA, IPInteresdelaDeuda, IPEndeudamientoNeto, IPGastoPCP, IPProgramasyPI, IPIndicadoresR, TQEstructuradIMPPAyS, TQProgramasCRFPODG, TQFondodAFplSP, TQInformaciondOPoGcFF, TQEjercicioyDdGFyR, TQAportacionesFdlFdAplE, TQAplicaciondRFORTAMUN, IPResumenFdFIPF, TQAportacionesFeMdS,InventarioBienesI,InventarioBienesM, NelerFTransferido, NpalpIaPredEgresos, NpalpleyPredEgresos, NpaEeIngresosBaseM, NpalecEgresosBaseM, NpaLeydeIngresos, RefEntiFederativas,} from "../json/anioArmonizacion";

export const obtenerDatosSeleccionados = (selectedItemIndex) => {
  let datosSeleccionados = [];

  switch (selectedItemIndex) {
    case ' Estado de Actividades':
      datosSeleccionados = estadoActividades;
      break;
    case ' Estado de Situación Financiera':
      datosSeleccionados = situacionfinanciera;
      break;
   /* case 'Disciplina Financiera':
      datosSeleccionados = disciplinaFinanciera;
      break;
    case 'Información Presupuestaria':
      datosSeleccionados = informacionPresupuestaria;
      break;
    case 'Cuenta Pública 2022':
      datosSeleccionados = CuentaPublicaA;
      break;*/
    case ' Estado de Variación en la Hacienda Pública':
      datosSeleccionados = ACvariacionHP;
      break;
    case ' Estado de Cambios en la situación financiera':
        datosSeleccionados = ACEstadoCambiosSF;
      break;
    case ' Estado de pasivos contingentes':
        datosSeleccionados = ACEstadoPasivosC;
      break;  
    case ' Notas a los estados financieros':
        datosSeleccionados = ACNotasEF;
      break;  
    case ' Estado analítico del activo':
        datosSeleccionados = ACEstadoAnaliticoA;
      break;  
    case ' Estado de flujo de efectivo':
        datosSeleccionados = ACEstadoFlujoE;
      break;  
    case ' Estado analítico de la deuda y otros pasivos':
        datosSeleccionados = ACEstadoAnaliticoDyOP;
      break;  
    case 'Estado analítico de ingresos':
        datosSeleccionados = IPEstadoAnaliticoI;
      break;  
    case 'Estado analítico del ejercicio del presupuesto de egresos en clasificación por objeto del gasto':
        datosSeleccionados = IPEstadoAnaliticoEPECPOG;
      break;
    case 'Estado analítico del ejercicio del presupuesto de egresos en clasificación ecónomica (por tipo de gasto)':
        datosSeleccionados = IPEstadoAnaliticoEPEPCE;
      break;   
    case 'Estado analítico del ejercicio del presupuesto de egresos en clasificación funcional':
        datosSeleccionados = IPEstadoAnaliticoEPECF;
      break; 
    case 'Estado analítico del ejercicio del presupuesto de egresos en clasificación programática':
        datosSeleccionados = IPEstadoAnaliticoEPECP;
      break; 
    case 'Estado analítico del ejercicio del presupuesto de egresos en clasificación administrativa':
        datosSeleccionados = IPEstadoAnaliticoEPECA;
      break; 
    case 'Endeudamiento neto':
        datosSeleccionados = IPEndeudamientoNeto;
      break; 
    case 'Interés de la deuda':
        datosSeleccionados = IPInteresdelaDeuda;
      break;   
    case 'Resumen flujo de fondos (indicadores de la postura fiscal)':
        datosSeleccionados = IPResumenFdFIPF;
      break;    
    case 'Gasto por categoría programática':
        datosSeleccionados = IPGastoPCP;
      break;     
    case 'Programas y proyectos de inversión':
        datosSeleccionados = IPProgramasyPI;
      break;       
    case 'Indicadores de resultados':
        datosSeleccionados = IPIndicadoresR;
      break;     
    case 'Estructura de información de montos pagados por ayudas y subsidios':
        datosSeleccionados = TQEstructuradIMPPAyS;
      break; 
    case 'Programas con recursos federales por orden de gobierno':
        datosSeleccionados = TQProgramasCRFPODG;
      break;    
    case 'Aportaciones federales en materia de salud':
        datosSeleccionados = TQAportacionesFeMdS;
      break; 
    case 'Fondo de ayuda federal para la seguridad pública':
        datosSeleccionados = TQFondodAFplSP;
      break; 
    case 'Información de obligaciones pagadas o garantizadas con fondos federales':
        datosSeleccionados = TQInformaciondOPoGcFF;
      break;
    case 'Ejercicio y destino de gasto federalizado y reintegros':
        datosSeleccionados = TQEjercicioyDdGFyR;
      break;
    case 'Aportaciones federales de los fondos de aportaciones para la educación básica y normal y de aportaciones para la educación tecnológica y de adultos':
        datosSeleccionados = TQAportacionesFdlFdAplE;
      break;
    case 'Aplicación de recursos del fondo de aportaciones para el fortalecimiento de los municipios y de las demarcaciones territoriales del Distrito Federal (FORTAMUN)':
        datosSeleccionados = TQAplicaciondRFORTAMUN;
      break;
   /* case 'Estado de la situación financiera detallado':
        datosSeleccionados = DPEstadoSFD;
      break;
    case 'Informe analítico de la deuda pública y otros pasivos':
        datosSeleccionados = DPEstadoSFD;
      break;
    case 'Informe análitico de obligaciones diferentes de financiamientos':
        datosSeleccionados = DPInformeAdODdF;
      break;
    case 'Balance presupuestario':
        datosSeleccionados = DPBalanceP;
      break;
    case 'Estado analítico de ingresos detallado':
        datosSeleccionados = DPEstadoAdID;
      break;
    case 'Estado analítico del ejercicio del presupuesto de egresos detallado Clasificación por objeto del gasto (capítulo y concepto)':
        datosSeleccionados = DPEstadoAdEdPdECOG;
      break;
    case 'Estado analítico del ejercicio del presupuesto de egresos detallado Clasificación administrativa':
        datosSeleccionados = DPEstadoAdEPdECA;
      break;
    case 'Estado analítico del ejercicio del presupuesto de egresos detallado Clasificación funcional (finalidad y función)':
        datosSeleccionados = DPEstadoAdEdCF;
      break;
    case 'Estado analítico del ejercicio del presupuesto de egresos detallado Clasificación de servicios personales por categoría':
        datosSeleccionados = DPEstadoAdPEdCSP;
      break;*/
    case 'Bienes muebles':
        datosSeleccionados = InventarioBienesM;
        break;
    case 'Bienes inmuebles':
        datosSeleccionados = InventarioBienesI;
        break;
    case 'Norma para armonizar la presentacion de la informacion adicional a la iniciativa de la ley de Ingresos':
        datosSeleccionados = NpaLeydeIngresos;
      break;
    case 'Norma para armonizar la presentación de la información adicional del proyecto del presupuesto de Egresos':
        datosSeleccionados = NpalpIaPredEgresos;
      break;
    case 'Norma para armonizar la difusión a la ciudadania de la ley de ingresos del presupuesto en Egresos':
        datosSeleccionados = NpalpleyPredEgresos;
      break;
    case 'Norma para establecer la estructura del calendario de Ingresos base mensual':
        datosSeleccionados = NpaEeIngresosBaseM;
      break;
    case 'Norma para establecer la estructura del calendario de Egresos base mensual':
        datosSeleccionados = NpalecEgresosBaseM;
      break;
    case 'Norma para establecer la estructura de información de la relación de las cuentas bancarias productivas especificas para presentar en la cuenta pública, en las cuales se depositen los recursos federales transferidos':
        datosSeleccionados = NelerFTransferido;       
      break;
    /*case 'Lineamintos de informacion ublica financiera para el fondo de aportaciones para infraestructura social':
        datosSeleccionados = LiffondopISocial;
      break;*/
    case 'Resultados de las evaluaciones de los recursos federales ministrados a las entidades federativas':
        datosSeleccionados = RefEntiFederativas;
      break;
    default:
      datosSeleccionados = [];
  }

  return datosSeleccionados;
};